import './styles/main.scss';
import data from './data';
import getProductsAction from './actions/getProducts.action';
import wishCounters from './components/wish.counters';
import wishButtons from './components/wish.buttons';
import addToWishlistAction from './actions/addToWishlist.action';
import removeFromWishlistAction from './actions/removeFromWishlist.action';
import { storageActionSet } from './actions/storage.action';
let wishTriggers;
void (async function () {
    wishTriggers = await import('../js/triggers').then(({ Triggers }) => new Triggers());
    wishTriggers.on('listUpdated', () => {
        storageActionSet(data.products);
    });
    wishTriggers.on('listUpdated', () => {
        data.itemCount = data.products.filter(i => !i.deletedFromMeta).length;
    });
    wishCounters();
    await getProductsAction();
    wishTriggers.emitEvent('listUpdated', [data.products]);
    wishButtons();
    window.wishlist = {
        add: addToWishlistAction,
        remove: removeFromWishlistAction,
        getData: () => data,
        on: wishTriggers.on,
        once: wishTriggers.once
    };
    document.dispatchEvent(new window.CustomEvent('wishlistLoaded'));
}());
export { wishTriggers };
